import { HomeAccountIcon } from './HomeAccountIcon';

/**
 * author: GreenTurtwig
 * id 9A7BCD6C-B4FB-4AE5-B22F-C5B8E2FB3B66
 * name home-account
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-account.svg
 * tags
 * - Account / User 
 * - Home Automation 
 */
export const HomeUserIcon = HomeAccountIcon;
export default HomeUserIcon